//types
import type { AlbumCardGridLayoutType, AlbumCardMedia } from '@/lib/albums/types';

//libs
import { getCardGridStyles } from '@/lib/albums/getCardGridStyles';
import { TIKTOK_BUSINESS } from '@/lib/socialProfile';

//components
import { MediaGridImage } from '@/components/pages/albums/AlbumCardMediaGrid/MediaGridImage';

function MediaGridTiktok({
    medias,
    gridLayout
}: {
    medias: AlbumCardMedia[];
    gridLayout: AlbumCardGridLayoutType;
}) {
    const renderedMedias = medias.length > 3 ? medias.slice(0, 3) : medias;

    return (
        <>
            {renderedMedias.map((media, index) => (
                <span
                    data-testid={`grid-tiktok-${media.type}`}
                    key={index}
                    className={getCardGridStyles({
                        index: index + 1,
                        size: renderedMedias?.length,
                        network: TIKTOK_BUSINESS,
                        gridLayout
                    })}>
                    {medias.length === 1 ? (
                        <span
                            className="relative h-full w-full overflow-hidden rounded-md"
                            data-testid="grid-single-image">
                            <MediaGridImage
                                index={index}
                                image={media.medias?.[0]?.image ?? media?.medias?.[0]?.thumbnail}
                                type={media?.type}
                                size={medias?.length}
                                gridLayout={gridLayout}
                            />
                        </span>
                    ) : (
                        <MediaGridImage
                            index={index}
                            image={media.medias?.[0]?.image ?? media?.medias?.[0]?.thumbnail}
                            type={media?.type}
                            size={medias?.length}
                            gridLayout={gridLayout}
                        />
                    )}
                </span>
            ))}
        </>
    );
}

export default MediaGridTiktok;
